import React, { useMemo } from 'react';
import styles from './stages.module.scss';
import parse from 'html-react-parser';

/* Assets */
import success from '../../../assets/icons/shop/success@3x.png';
/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';

/* Interfaces */
import { useTipsterRoutesContext } from '../__providers__/TipsterRoutesProvider';

interface PaymentSuccessPremiumProps {
  tipsterName: string;
  tipsterId: string;
  until: string;
  referralCode: string;
}

export const PaymentSuccessPremium: React.FC<PaymentSuccessPremiumProps> = ({
  tipsterName,
  until,
  tipsterId,
  referralCode,
}) => {
  const { t } = useTranslation();
  const { getAdjustID } = useTipsterRoutesContext();
  const isMobile = useMemo(() => {
    return navigator.userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
    );
  }, []);
  const isDesktop = useMemo(() => {
    return navigator.userAgent.includes('Mac') ? { iOS: true } : { iOS: false };
  }, []);

  const appLink = useMemo(() => {
    if (isMobile) {
      const adjustID = getAdjustID(tipsterId);
      return `https://2u6n.adj.st/follow?tipster_id=${tipsterId}&source=tipster&adj_t=${adjustID}&adj_deep_link=tipsterchat%3A%2F%2Ffollow%3Ftipster_id%3D${tipsterId}%26source%3Dtipster&referral_code=${referralCode}`;
    } else if (isDesktop.iOS) {
      return `https://apps.apple.com/app/id1397786773?mt=8`;
    } else {
      return `https://play.google.com/store/apps/details?id=com.tipsterchat&hl=es_419&gl=US`;
    }
  }, []);

  return (
    <div className={styles.card}>
      <div className={styles.paymentSuccess}>
        <img src={success} alt="success box" />
        <h1>{tr(t, 'shop_success-title')}</h1>
        <p>
          {parse(
            t('shop_success-message_PREMIUM', {
              tipster: tipsterName,
              date: until,
            }),
          )}
        </p>
        <div className={styles.CTABtnWrapper}>
          <a href={appLink}>{tr(t, 'open_app')}</a>
        </div>
      </div>
    </div>
  );
};
